<template>
  <page-template>
    <template slot="page-content">
      <div class="generic--template page-template bg-brown pb6">
        <!-- CONTENT -->
        <div class="relative container-fluid mw8 center z-content">
          <section class="row relative center tl">
            <h1 class="f-page-title ttu tl lh-title f2 f1-ns is-blenny is-black">
              {{ page.title }}
            </h1>
          </section>
          <section class="db relative mw6">
            <SMSSignupForm />
          </section>
        </div>
      </div>
    </template>
  </page-template>
</template>

<script>
import PageTemplate from "./page-template.vue";
import SMSSignupForm from "./signup-form-sms.vue";
export default {
  components: {
    PageTemplate,
    SMSSignupForm,
  },
  props: ["id", "pageMarkdownFileName"],
  metaInfo() {
    return {
      title: this.page.seo_title,
      titleTemplate: (titleChunk) => {
        return titleChunk
          ? `${titleChunk} | ` + this.$site_seo_title_suffix
          : this.$site_seo_title_suffix;
      },
      meta: [
        { vmid: "description", name: "description", content: this.page.seo_description },
      ],
    };
  },
  computed: {
    page: function () {
      var pageData = this.$store.getters.filterPagesByName(this.pageMarkdownFileName);
      return pageData[0];
    },
  },
  created() {},
};
</script>

<style></style>
